"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
class Start extends webix_jet_1.JetView {
    config() {
        return {
            view: "iframe",
            id: "frame-body1",
            width: 900,
        };
    }
    constructor(app, config) {
        super(app, config);
    }
    init() {
        let dem = $$("frame-body1");
        dem.load("https://help.alnitac.com/start");
    }
}
exports.default = Start;
